import { Alert, Button } from 'antd'
import { useContext, useEffect, useState } from 'react'

import AppContext from './AppContext'
import ReactMarkdown from 'react-markdown'
import { formatDateTime } from '../../util/dateTimeUtil'
import { hideMessageId } from '../../util/cookieUtil'
import { transformMarkdownUri } from '../../util/commonUtil'

const Message = ({ message, adminMode }) => {
  const { setMessageHidden } = useContext(AppContext)
  const [visible, setVisible] = useState(true)
  if (!message) {
    return null
  }

  const wrapContent = (content) => {
    return <div style={{ marginRight: '40px' }}>{content}</div>
  }

  const hideMessage = (id, messageUpdatedAt) => {
    if (adminMode) {
      // Don't hide if the message is being viewed in admin mode, since that mode is for managing messages and seeing hidden messages
      return
    }
    // persist hide preference in a cookie so this message won't show again
    try {
      hideMessageId(id, messageUpdatedAt)
      if (typeof setMessageHidden === 'function') {
        setMessageHidden(true)
      } else {
        console.error('No message hide callback available on AppContext')
      }
    } catch (e) {
      console.error('Failed to hide message', e)
    }
    setVisible(false)
  }
  const wrapDescription = (content) => {
    const postedOn = message.updatedAt ? `Posted ${formatDateTime(message.updatedAt, 'EEE MMM d, h:mma')}` : null
    return (
      <div>
        <div>{wrapContent(content)}</div>
        <div
          className="note"
          style={{
            color: '#888',
            position: 'absolute',
            bottom: '0em',
            right: '0em',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            fontSize: '.8em',
          }}
        >
          {postedOn}
          <Button
            style={{ fontSize: '1.1em', paddingRight: '5px', color: 'hsl(210,90%,40%)' }}
            onClick={() => hideMessage(message.id, message.updatedAt)}
            type="link"
          >
            Click to hide
          </Button>
        </div>
      </div>
    )
  }

  // Custom link component that stops click propagation
  const MarkdownLink = ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()} // Intercepts the click!
    >
      {children}
    </a>
  )

  return (
    visible && (
      <Alert
        className="message"
        style={{ minHeight: '7em' }}
        message={wrapContent(message.heading)}
        description={wrapDescription(
          <ReactMarkdown
            children={message.content}
            transformImageUri={transformMarkdownUri}
            components={{
              a: MarkdownLink,
            }}
          />,
        )}
        type={message.messageType}
        onClick={() => hideMessage(message.id, message.updatedAt)}
      />
    )
  )
}

export default Message
